export function FloatingActionBar({
  dockOpen,
  isVisible,
  floatingActions,
  favoriteSlugs,
  activeMarket
}) {
  if (!isVisible) return null;

  return (
    <div className={`glass-md fixed left-1/2 bottom-4 -translate-x-1/2 flex gap-2 md:gap-3.5 px-3 md:px-4 py-2.5 md:py-3 rounded-full shadow-float z-40 max-w-[calc(100vw-32px)] overflow-x-auto transition-opacity duration-300 ${dockOpen ? 'opacity-0 pointer-events-none lg:opacity-100 lg:pointer-events-auto' : ''}`}>
      {floatingActions.map((action) => {
        const isFavActive = action.key === 'favorite' && favoriteSlugs.has((activeMarket && activeMarket.id) || '');
        return (
          <button
            key={action.key}
            onClick={action.onClick}
            title={action.label}
            className={`flex items-center gap-2 border-none rounded-full px-3.5 py-2.5 bg-slate-900/70 text-text text-xs md:text-sm cursor-pointer border flex-shrink-0 min-w-[48px] md:min-w-0 ${isFavActive ? 'border-sky-400/60 text-sky-50 bg-sky-400/20' : 'border-slate-600/50 hover:border-accent'}`}
          >
            <action.icon className="text-sm md:text-base" />
            <span className="hidden md:inline">{action.label}</span>
          </button>
        );
      })}
    </div>
  );
}
